// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Chapter----index-module---root---2DzQ3","title":"src-components-Chapter----index-module---title---2n1CH","divider":"src-components-Chapter----index-module---divider---ji89r","subTitle":"src-components-Chapter----index-module---subTitle---3jNYb","text":"src-components-Chapter----index-module---text---3mY_h","chapterContent":"src-components-Chapter----index-module---chapterContent---2sOlz","chapterContentInner":"src-components-Chapter----index-module---chapterContentInner---1toM7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Chapter/index.module.css
// module id = 597
// module chunks = 164721891013254